<template>
  <span v-html="getSvg(props.name)" class="zt-image-svg" />
</template>
<script lang="ts" setup>
import get from 'lodash/get';
import * as svg from './../theme/icons';

const props = defineProps<{
  name: string;
}>();

const getSvg = (name: string) => {
  const image = get(svg, name, null);
  if (name === null) {
    console.warn(`[ImageComponent] - cannot find svg ${props.name}`);
  }

  return image;
};
</script>

<style scoped>
.zt-image-svg :deep(svg) {
  @apply w-full h-full;
}
</style>
